// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const WebAppCandidateVerdictSchema = z.enum(['CUSTOM','SAAS','NOT_WEB'] as const);

export type WebAppCandidateVerdictType = `${z.infer<typeof WebAppCandidateVerdictSchema>}`

export default WebAppCandidateVerdictSchema;
